import { t } from '@/features/i18n/utils';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { ExtractionsPage } from '@/features/extractions/components/extractions-page';
import z from 'zod';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/extractions',
)({
  staticData: { chatSurface: 'custom_topic' },
  component: RouteComponent,
  validateSearch: z.object({
    id: z.string().optional(),
    extractionId: z.string().optional(),
    queryId: z.string().optional(),
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { workspaceId, projectId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Extractions', nb: 'Uttrekk' })}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <ExtractionsPage />
    </>
  );
}
